import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import Style from './style.scss';
import { withRouter, Link, Prompt } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import * as C_R from '../../constants/routes';
import C from '../../constants/app';
import Cx from 'classnames';
import styled from 'styled-components';
import * as ChargerActions from '../../actions/app';
import * as AlertActions from '../../actions/alert';
import * as AnalyticsAction from '../../actions/analytics';
import {bindActionCreators} from 'redux';
import C_ALERT from  '../../constants/alert';
import AlertStyle from '../Alert/style.scss';
import {getFullDateTimeFormatByCulture} from '../../utils/helpers';
import CustomHelmet from '../utils/CustomHelmet';
import userC from '../../constants/user';



const StyledCompTitle = styled.h1`
    color: ${props => props.theme.headlineColor};	
`;

const StyledTitleIcon = styled.span`
    color: ${props => props.theme.headlineColor}; 
`;



class IframeComp extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			changes: false
		};
		this.execute = this.execute.bind(this);
		this.setIframeRef = this.setIframeRef.bind(this);
        this.iframeFuncs ={
            startCharger: () => {
                this.props.chargerActions.setFetchingCount(true);
            },
            closeCharger: () => {
                this.showIframe();
                this.props.chargerActions.closeCharger();
            },
            setChange: (changes) => {
                this.setState({changes: changes});
            },
            reportAndNavigate:this.reportAndNavigate.bind(this),
			report:this.report.bind(this),
            setIframeHeight:this.setIframeHeight.bind(this),
            customAlert:this.customAlert.bind(this)
        };
		//
		this.initByPathFuncs = {
            [C_R.ACTION_PATH_PARAMS]: this.initActionItemPathParams.bind(this)
		}
	}


    initActionItemPathParams(){
        let queryString = window.location.search;
        if (queryString.length>0){queryString = queryString.replace('?','&')}
        let id = this.props.match.params.id;
        let status = id.split(':')[3]||-1;
        if ([C.STATUS_DISABLED, C.STATUS_COMPLETED].indexOf(status) >=0) {
            this.setState({changes: false});
        }
	}
    componentWillMount() {
		this.props.chargerActions.setFetchingCount(true);
        if (this.initByPathFuncs[this.props.match.path]) {
            this.initByPathFuncs[this.props.match.path]()
        }
    }
	componentDidMount() {
		this.resizeEvent = this.setIframeHeight.bind(this);
		this.checkIframeLoaded();
    }

	shouldBlockNavigation() {
		// apply discard prompt only on the pages in this array.
		return ([C_R.INCIDENT_PATH, C_R.SR_PATH, C_R.ACTION_PATH_PARAMS].indexOf(this.props.match.path) !== -1 && this.state.changes);
	}

	navigateWithoutPrompt() {
		this.setState({changes: false}, () => this.props.history.push(C_R.ROOT_PATH));
	}

	reportAndNavigate(data) {
		this.report(data);
		this.navigateWithoutPrompt();
        this.props.chargerActions.closeCharger();
	}

    report(data){
        this.props.analyticActions.reportAnalytics([data.category, data.action]);
    }

    initAlertFromChild(){
        this.props.alertActions.toggleAlert(false);

        // let alertType  = document.getElementById('actionValue').value;
        let alertType  = this.refs.actionValue.value;
        let responseObject;

        // if (document.getElementById('responseObjectValue').value.length) {
		if (this.refs.responseObjectValue.value.length) {
            responseObject = JSON.parse(this.refs.responseObjectValue.value);
        }

        let alertIcon;
        let alertTitle;
        let alertText;
        let alertStyle;
        let errorIcon = 'errorIcon';
        let successIcon = 'successIcon';
        let displayTime;
        let closeButton;

        let dueDateText;
        let assignedToText;

        switch (alertType) {
            case C_ALERT.MANDATORY_FIELDS_ERR:
                alertIcon = errorIcon;
                alertTitle = this.props.intlObject['ssp.alert.mandatory.fields.title'];
                alertText = this.props.intlObject['ssp.alert.mandatory.fields.text'];
                alertStyle = 'danger';
                displayTime = 3000;
                break;

            case C_ALERT.FORM_SUBMIT_SUCCESS:
                if (responseObject.due_date) {
                    dueDateText = <div>{this.props.intlObject['ssp.alert.form.submit.success.due.by']} {responseObject.due_date}.</div>;
                }
                if (responseObject.assigned_to) {
                    assignedToText = <div>{this.props.intlObject['ssp.alert.form.submit.success.assigned.to']} {responseObject.assigned_to}.</div>;
                }

                alertIcon = successIcon;
                alertTitle = <span>
					{this.props.intlObject['ssp.alert.form.submit.success.1.a'] + ' '}
					{this.props.intlObject[`ssp.alert.form.submit.${responseObject.type}`] + ' '}
                    {<Link to={`/SRview/${responseObject.id}`}
                           className={AlertStyle.alertLink}>{`${this.props.intlObject['ssp.idPrefix']}${responseObject.id}`}</Link>}{'. '}
                    {this.props.intlObject['ssp.alert.form.submit.success.1.b']}
							</span>;
                alertText = <div>{dueDateText}{assignedToText}</div>;
                alertStyle = 'success';
                displayTime = 10000;
                closeButton = true;
                break;
            case C_ALERT.WORKFLOW_SUBMIT_SUCCESS:
                alertIcon = successIcon;
				alertTitle = `${this.props.intlObject['ssp.alert.workflow.update.success']} ${this.props.intlObject['ssp.idPrefix']}${responseObject.id}`;
                alertText = '';
                alertStyle = 'success';
                displayTime = 10000;
                closeButton = true;
                break;
            case C_ALERT.WORKFLOW_UPDATE_FAILED:
                alertIcon = errorIcon;
                alertTitle =
                    `${this.props.intlObject['ssp.alert.workflow.update.failed.1']} ${this.props.intlObject['ssp.idPrefix']}${responseObject.id} ${this.props.intlObject['ssp.alert.workflow.update.failed.2']}`;
                alertText = '';
                alertStyle = 'danger';
                displayTime = 10000;
                closeButton = true;
                break;
            case C_ALERT.INVALID_ID:
                alertIcon = errorIcon;
                alertTitle = `${this.props.intlObject['ssp.alert.form.submit.failure.invalidid']} ${responseObject.id}`;
                alertText = '';
                alertStyle = 'danger';
                displayTime = 3000;
                break;
            case C_ALERT.NO_PERMISSION:
                alertIcon = errorIcon;
                alertTitle = this.props.intlObject['ssp.alert.form.submit.failure.nopermission'];
                alertText = '';
                alertStyle = 'danger';
                displayTime = 3000;
                break;
            case C_ALERT.POPULATE_ERROR:
                alertIcon = errorIcon;
                alertTitle = this.props.intlObject['ssp.alert.form.submit.failure.populateError'];
                alertText = '';
                alertStyle = 'danger';
                displayTime = 3000;
                break;
            case C_ALERT.SUBMIT_ERROR:
                alertIcon = errorIcon;
                alertTitle = this.props.intlObject['ssp.alert.form.submit.error'];
                alertText = '';
                alertStyle = 'danger';
                displayTime = 3000;
                break;
			case C_ALERT.STORAGE_MANAGEMENT_APPLY:
                alertIcon = errorIcon;
                alertTitle = `${this.props.intlObject['ssp.alert.form.apply.storage.management.title']}`;
                alertText = this.props.intlObject['ssp.alert.form.submit.storage.management.text'];
                alertStyle = 'warning';
                displayTime = 10000;
                closeButton = true;
                break; 
            case C_ALERT.STORAGE_MANAGEMENT:
                alertIcon = errorIcon;
                alertTitle = `${this.props.intlObject['ssp.alert.form.submit.storage.management.title']} ${responseObject.type} ${this.props.intlObject['ssp.idPrefix']}${responseObject.id}`;
                alertText = this.props.intlObject['ssp.alert.form.submit.storage.management.text'];
                alertStyle = 'warning';
                displayTime = 10000;
                closeButton = true;
                break; 
        }
        let alertData =  {alertIcon, alertTitle, alertText, alertStyle, displayTime, closeButton};

        this.props.alertActions.initAlert(alertData);
    }

    render() {
        const {iframeSrc, compTitle, pageTitle} = this.iframeSrcByRoute();
		const isBlockNavigation = this.shouldBlockNavigation();
        return (
			<div>
				<CustomHelmet>
					<title>{`${pageTitle} - ${this.props.intlObject['ssp.page.title']}`}</title>
				</CustomHelmet>
				<button onClick={this.execute} style={{display:'none'}} id='executeBtn' />
				<input type='hidden' id='actionValue' value='' ref='actionValue' />
				<input type='hidden' id='responseObjectValue' value='' ref='responseObjectValue' />
				{compTitle}
				<iframe id='formFrame'
						key={iframeSrc}
						src={iframeSrc}
						style={{visibility: 'hidden'}}
                        className={Style.iframe}
						scrolling='yes'
						allowFullScreen
						title={pageTitle}
						ref={this.setIframeRef}>
				</iframe>
				<Prompt when={isBlockNavigation} message={this.props.intlObject['ssp.discardChanges']} />
			</div>
		)
	}

	setIframeRef(iframe) {
        if (iframe) {
            this._iframe = iframe;
            this._innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        }
    }

    componentWillReceiveProps(next) {
        if (this.props.match.url !== next.match.url) {
            this.hideIframe();
        }
    }

	componentDidUpdate() {
		this.checkIframeLoaded();
	}

    componentWillUnmount() {
        window.removeEventListener( 'resize', this.resizeEvent );
        if (typeof document.getElementById('formFrame').contentWindow.removeComboClickEvent === 'function') {
            document.getElementById('formFrame').contentWindow.removeComboClickEvent();
        }
		this.props.chargerActions.closeCharger();
    }

	/* assigning the iframe src by router path */

	iframeSrcByRoute() {
		// let path = this.props.pathName;
		let path = this.props.match.path;
		let queryString = window.location.search;
		if (queryString.length>0){queryString = queryString.replace('?','&')}
		let id = this.props.match.params.id;
		let iframeSrc;
		let compTitle;
		let titleIcon;
		let titleText;
		let [actionId, pageId, subPageId] = [];
        let pageTitle;

        switch (path) {
            case C_R.ACTION_PATH_PARAMS:
                [actionId, pageId, subPageId] = id.split(':');
                iframeSrc = `/ActionItemEditSelfServicePortal.jsp?id=${actionId}&pageID=${pageId}&subPageID=${subPageId}${queryString}`;
                titleIcon = <StyledTitleIcon className={Cx('iconIssue', 'editIcon', Style.titleIcon)} ></StyledTitleIcon>;
                titleText = this.props.intlObject['ssp.iframe.title.action.edit'];
                pageTitle = `${this.props.intlObject['ssp.page.title.action.edit']} ${this.props.intlObject['ssp.idPrefix']}${actionId}`;
                break;
			case C_R.SR_PATH:
				iframeSrc = `/SubmitSRSelfServicePortal.jsp?srType=request&resetBeans=true${queryString}`;
                titleIcon = <StyledTitleIcon className={Cx('iconIssue', 'requestTitleIcon', Style.titleIcon)} ></StyledTitleIcon>;
                titleText = this.props.intlObject['ssp.iframe.title.submit.sr'];
                pageTitle = this.props.intlObject['ssp.page.title.submit.request'];
                break;
			case C_R.INCIDENT_PATH:
				iframeSrc = `/SubmitSRSelfServicePortal.jsp?resetBeans=true${queryString}`;
				// titleIcon = <img src={incidentIcon}  alt="Submit Incident"/>;
                titleIcon = <StyledTitleIcon className={Cx('iconIssue', 'incidentTitleIcon', Style.titleIcon)} ></StyledTitleIcon>;
                titleText = this.props.intlObject['ssp.iframe.title.submit.incident'];
                pageTitle = this.props.intlObject['ssp.page.title.submit.incident'];
                break;
			default:
				iframeSrc = '';
				titleIcon = <Glyphicon glyph="remove"/>;
				titleText = 'Nothing here, shoo!';
		}
		compTitle = <div aria-label={titleText} tabIndex='0'  id="titleWrapperDiv" className={Style.titleWrapper}>{titleIcon}<StyledCompTitle className={Style.compTitle}>{titleText}</StyledCompTitle></div>;
        return {iframeSrc, compTitle, pageTitle};
	}

	hideIframe() {
		this._iframe.style.visibility = 'hidden';
	}

	showIframe () {
		this._iframe.style.visibility = 'visible';
	}

	addResizeEvent() {
		window.addEventListener( 'resize', this.resizeEvent );
	}

	injectCss() {
		var doc = this._iframe.contentDocument || this._iframe.contentWindow.document;
		this._iframe.addEventListener('load', iframeLoadedCallback);
		var self = this;

		function iframeLoadedCallback() {
			if (doc !== self._iframe.contentDocument && doc !== self._iframe.contentWindow.document) {
				doc = self._iframe.contentDocument || doc !== self._iframe.contentWindow.document;
			}
			
			self.setIframeHeight();

			setTimeout(function(){
				self.showIframe();
                self.props.chargerActions.closeCharger();
			}, 0);
			
			self._iframe.removeEventListener('load', iframeLoadedCallback);
			self.addResizeEvent();
		}
	}

    injectTheme() {
		localStorage.theme = JSON.stringify(this.props.theme);
        localStorage.dateTimeFormat = getFullDateTimeFormatByCulture(this.props.dateFormat);
    }


	setIframeHeight(){

		let iframeElm = this._iframe,
			iframeRoot = iframeElm.contentDocument,
			iframeDocument = iframeRoot.documentElement,
			iframeInnerElm = iframeRoot.querySelector('#sspContent') || iframeRoot.querySelector('body'),
			iframeHeight;

		// Adjust height based on content height
		iframeHeight = Math.max(iframeInnerElm.scrollHeight, iframeInnerElm.offsetHeight);
		// Minimum of 200 is required
		iframeHeight = iframeHeight > 200 ? iframeHeight : 200;
		// Adjust height in CSS (must end with a unit)
		iframeElm.style.height = iframeHeight + 'px';

		// Re-adjust based on Document height (extra spacing issue)
		iframeHeight = Math.max(iframeDocument.scrollHeight, iframeDocument.offsetHeight);
		iframeElm.style.height = iframeHeight + 'px';
	}

	// This function ONLY works for iFrames of the same origin as their parent
	// see: http://stackoverflow.com/a/24621957/1723752
	// and http://stackoverflow.com/questions/24603580/how-can-i-access-the-dom-elements-within-an-iframe/24603642#comment38157462_24603642
	iFrameReady(iFrame, fn) {
		var timer;
		var fired = false;

		function ready() {
			if (!fired) {
				fired = true;
				clearTimeout(timer);
				fn.call(this);
			}
		}

		function readyState() {
			if (this.readyState === 'complete') {
				ready.call(this);
			}
		}

		// cross platform event handler for compatibility with older IE versions
		function addEvent(elem, event, fn) {
			if (elem.addEventListener) {
				return elem.addEventListener(event, fn);
			} else {
				return elem.attachEvent('on' + event, function () {
					return fn.call(elem, window.event);
				});
			}
		}

		// use iFrame load as a backup - though the other events should occur first
		// addEvent(iFrame, 'load', function () {
		// 	ready.call(iFrame.contentDocument || iFrame.contentWindow.document);
		// });

		function checkLoaded() {
			var doc = iFrame.contentDocument || iFrame.contentWindow && iFrame.contentWindow.document;
			// We can tell if there is a dummy document installed because the dummy document
			// will have an URL that starts with 'about:'.  The real document will not have that URL
			if (doc && doc.URL.indexOf('about:') !== 0) {
				if (doc.readyState === 'complete') {
					ready.call(doc);
				} else {
					// set event listener for DOMContentLoaded on the new document
					addEvent(doc, 'DOMContentLoaded', ready);
					addEvent(doc, 'readystatechange', readyState);
				}
			} else {
				// still same old original document, so keep looking for content or new document
				timer = setTimeout(checkLoaded, 1);
			}
		}
		checkLoaded();
	}

	checkIframeLoaded() {
		// Check if loading is complete
		if (this._innerDoc != undefined) {
			this.iFrameReady(this._iframe, () => {
				this.injectCss();
                this.injectTheme();
			});
		}
	}
    execute(e) {
		let params = JSON.parse(e.target.getAttribute('data-params'));
        if (typeof this.iframeFuncs[params.action] === 'function') {
            this.iframeFuncs[params.action](params.data);
        }
    }

	customAlert(){
        this.props.alertActions.toggleAlert(false);
        this.initAlertFromChild();
        this.props.alertActions.toggleAlert(true);
	}
}

IframeComp.propTypes = {
	history: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired,
	intlObject: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    chargerActions: PropTypes.object.isRequired,
	alertActions: PropTypes.object.isRequired,
    dateFormat:PropTypes.string.isRequired,
    analyticActions:PropTypes.object.isRequired
};


function mapStateToProps(state) {
    return {
        theme: state.app.get(C.THEME),
        dateFormat:  state.user.getIn([userC.INPUT_DATE])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        chargerActions: bindActionCreators(ChargerActions, dispatch),
		alertActions: bindActionCreators(AlertActions, dispatch),
		analyticActions:bindActionCreators(AnalyticsAction, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IframeComp));


// WEBPACK FOOTER //
// ./components/Iframe/IframeComp.js